import * as React from 'react';
import { Input, InputProps, message, Tooltip } from '@easyv/react-components';

export interface ProInputProps extends Omit<InputProps, 'onChange' | 'value' | 'onBlur'> {
  showToolTip?: boolean;
  name: string;
  allowEmpty?: boolean;
  value: string | undefined;
  hideSuffixWhenInput?: boolean;
  hidePrefixWhenInput?: boolean;
  onChange?: (name: string, value: string) => void;
  onBlur: (name: string, value: string) => void;
}

export const ProInput: React.FC<ProInputProps> = (props) => {
  const {
    value,
    name,
    allowEmpty = false,
    showToolTip = false,
    suffix,
    prefix,
    hideSuffixWhenInput,
    hidePrefixWhenInput,
    onBlur,
    onChange,
    ...rest
  } = props;

  const [showValue, setShowValue] = React.useState<string | undefined>(undefined);
  const oldValue = React.useRef<string>(); // 输入的同时引擎的真实值也发生变化了,所以只能在这里存储输入前的旧值,用于判断是否值发生变化
  const [isInputing, setIsInputing] = React.useState(false);

  React.useEffect(() => {
    setShowValue(value);
  }, [value]);

  const handleBlur = (inputValue: string) => {
    if (oldValue.current !== undefined && oldValue.current === inputValue) {
      return;
    }
    if (!allowEmpty && inputValue.length === 0) {
      message.error('输入不能为空');
      oldValue.current && onChange?.(name, oldValue.current);
    } else onBlur(name, inputValue);
  };

  return (
    <Tooltip
      triggerProps={{
        showArrow: false,
        position: 'bottom',
        popupAlign: { bottom: [0, 2] },
        className: 'model-customattribute-tooltip',
      }}
      content={showToolTip && !isInputing ? value : undefined}
    >
      <Input
        size='small'
        autoComplete='off'
        name={name}
        value={showValue}
        suffix={hideSuffixWhenInput && isInputing ? <div /> : suffix}
        prefix={hidePrefixWhenInput && isInputing ? <div /> : prefix}
        onPressEnter={(event: any) => {
          const e = event as React.KeyboardEvent<HTMLElement>;
          if (e.key === 'Enter') {
            (e.target as HTMLElement).blur();
          }
        }}
        onBlur={(e: any) => {
          handleBlur(e.target.value);
          oldValue.current = undefined;
          setIsInputing(false);
        }}
        onFocus={(e: any) => {
          setIsInputing(true);
          e.target.select();
          oldValue.current = value;
        }}
        onChange={(exp: any) => {
          setShowValue(exp);
          if (exp !== undefined) onChange?.(name, exp);
        }}
        {...rest}
      />
    </Tooltip>
  );
};
